import React from "react";
import TopBanner from "./TopBanner";
import { useTheme } from "../../context/ThemeContext";

interface SharedLayoutProps {
  formTitle?: string;
  loading?: boolean;
  hideTopBanner?: boolean;
  hideAdd?: boolean;
  addPermission?: string[];
  animationSize?: "eighty" | "sixty" | "largeForm" | "full";
  onAddItem?: () => void;
  onCloseDetails?: () => void;
  children?: React.ReactNode;
}

const SharedLayout: React.FC<SharedLayoutProps> = ({
  formTitle = "",
  loading = false,
  hideTopBanner = false,
  hideAdd = false,
  addPermission = [],
  animationSize = "eighty",
  onAddItem,
  children,
}) => {
  const { theme } = useTheme();

  const themeClasses =
    theme === "night" ? "bg-gray-400 text-white" : "bg-gray-50";

  return (
    /**
     * IMPORTANT:
     * - h-screen ➜ h-full min-h-0 to avoid forcing a nested viewport inside MainLayout
     * - keep two-row grid (banner + content)
     */
    <div
      className={`grid grid-rows-[auto,1fr] h-full min-h-0 w-full rounded-tl-3xl animation-size-${animationSize} ${themeClasses}`}
    >
      {!hideTopBanner && (
        <TopBanner
          title={formTitle}
          addButtonName="New Entry"
          useBackButton={true}
          addPermission={addPermission}
          hideAdd={hideAdd}
          onAddClicked={onAddItem}
          loading={loading}
        />
      )}

      {/* This is the ONLY scrolling area inside SharedLayout */}
      <main className="p-4 min-h-0 overflow-auto overscroll-contain">
        {loading ? (
          <div className="grid place-items-center min-h-full">
            <span>Loading...</span>
          </div>
        ) : (
          <div className="grid gap-4">{children}</div>
        )}
      </main>
    </div>
  );
};

export default SharedLayout;
